import SEOHead from "@/components/SEOHead";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Industries from "@/components/landing/Industries";
import HygieneSection from "@/components/landing/HygieneSection";
import Services from "@/components/landing/Services";
import Standards from "@/components/landing/Standards";
import MachineSpecs from "@/components/landing/MachineSpecs";
import PracticeGallery from "@/components/landing/PracticeGallery";
import Footer from "@/components/landing/Footer";
import { useT } from "@/i18n/LocaleContext";
import VisitorTracker from "@/components/VisitorTracker";

export default function LandingPage() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-white text-[var(--ci-grey)]" data-testid="landing-page">
      <VisitorTracker />
      <SEOHead path="/" />
      <Navbar />
      {/* SEO H1 – für Suchmaschinen sichtbar, visuell nicht dargestellt (Design bleibt unverändert). */}
      <h1 className="sr-only" data-testid="seo-h1">{t("meta.seoH1")}</h1>
      <main>
        <Hero />
        <Marquee />
        <PracticeGallery />
        <Industries />
        <HygieneSection />
        <Services />
        <Standards />
        <MachineSpecs />
      </main>
      <Footer />
    </div>
  );
}
